import { useEffect, useRef } from "react";
import lottie from "lottie-web";
import animationData from "../Animation/love-hearts.json";

const LoadingAnimation = () => {
    const containerRef = useRef();

    useEffect(() => {
        const anim = lottie.loadAnimation({
            container: containerRef.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: animationData,
        });
        return () => anim.destroy();
    }, []);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "80px",
                height: "350px",
            }}
        >
            <div ref={containerRef} style={{ width: "180px", height: "180px" }} />
            <p
                style={{
                    fontSize: "1.2em",
                    fontFamily: "Nanum Myeongjo",
                    letterSpacing: "0.25em",
                    color: "#aaa",
                    marginTop: "10px",
                }}
            >
                PLEASE WAIT...
            </p>
        </div>
    );
};

export default LoadingAnimation;